import { Languages, IndianRupee, MessageSquareDot, ClipboardCheck } from "lucide-react";

import Box from '../../components/Box';
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";

const teamMembers = [
    {
        icon: <Languages className="w-6 h-6" />,
        iconBg: "bg-blue-100",
        iconColor: "text-[#4949DE]",
        title: "AI Multilingual Communication Expert",
        description: "Talks to every parent in 10+ Indian languages through WhatsApp, IVR, app alerts, and 24/7 student information.",
    },
    {
        icon: <IndianRupee className="w-6 h-6" />,
        iconBg: "bg-blue-100",
        iconColor: "text-[#4949DE]",
        title: "AI Auto Fee Collection Manager",
        description: "Sends reminders, tracks payments, and ensures polite, on-time collections. No tele callers and no mobile bills.",
    },
    {
        icon: <MessageSquareDot className="w-6 h-6" />,
        iconBg: "bg-blue-100",
        iconColor: "text-[#4949DE]",
        title: "AI Parental Feedback Analyst",
        description: "Collects and analyses parent opinions",
    },
    {
        icon: <ClipboardCheck className="w-6 h-6" />,
        iconBg: "bg-blue-100",
        iconColor: "text-[#4949DE]",
        title: "AI Homework Assist",
        description: "Tracks, reminds, and updates homework status automatically",
    }
];

export default function EverythingYourSchoolNeedOperator() {

    return <Box
        badge={"YOUR OPERATIONS TEAM"}
        title={"Everything Your School Needs - Fully Automated"}
        leftBlock={teamMembers.slice(0, 2).map((member, index) => <MarktingCard key={"EverythingYourSchoolNeedOperator" + index} member={member} />)}
        rightBlock={teamMembers.slice(2).map((member, index) => <MarktingCard key={"EverythingYourSchoolNeedOperator" + index} member={member} />)}
    />;
}